module.exports = __webpack_public_path__ + "static/media/studio_mewp_180_atj_manitou_004.caccb38f.png";